
import { Dispatch } from 'redux';
import { LoginService } from "../../services/LoginService";
import { adminapi, orgapi } from "../../ApiNames";

export const fetcheditdatasuccess = (editdata:any)=>({
    type : 'fetch_Edit_data_success',
    payload:editdata
});
export const fetchDataSuccess = (data:any)=>({
    type : 'fetch_data_success',
    payload:data
});
export const fetchneedDataSuccess = (data:any)=>({
    type : 'fetch_needs_data_success',
    payload:data
});
export const EditData = (Id :any,uid:any,needId:any, needtittle: any, budget_amount: any, description: any)=>{
    return async (dispatch:Dispatch) =>{
        try{
            const payload = {needid:Id,uid:uid,needtype: needId, ntitle: needtittle, budget: budget_amount, description: description,q:11};
            const apiname = adminapi.ad_donordocument;
            const response = await LoginService.getData(apiname,payload);
            dispatch(fetcheditdatasuccess(response));
        }catch(error) {
            console.error('Error fetching data:', error);
        }
    }
};
export const fetchData = ()=>{
    return async (dispatch:Dispatch) =>{
        try{
            const payload = {};
            const apiname = adminapi.adneed;
            const response = await LoginService.getData(apiname,payload);
            dispatch(fetchDataSuccess(response));
        }catch(error) {
            console.error('Error fetching data:', error);
        }
    }
};

export const fetchneedData = (Id:any) => {
    return async (dispatch: Dispatch) => {
        try {
            const payload = {"need":Id,q:1};
            const apiname = orgapi.orgneedprofile;
            const response = await LoginService.getData(apiname,payload)
            dispatch(fetchneedDataSuccess(response));
        } catch (error) {
            console.error('Error fetching data:', error);
        }
    };
};


